<template>
  <div>
    <div class="banner_wa_a d-flex justify-center align-center">
      <div class="wa_a_left d-flex justify-center align-item">
        <div class="content-wa-a-left pl-12" style="line-height: 34px">
          <p style="font-size: 32px">
            <b>Konsultasi & Informasi Lebih Lanjut Terkait Jurusan Kuliah</b>
          </p>
          <p class="mt-n4">Konsultasi melalui WhatsApp secara GRATIS!</p>
          <div class="d-flex justify-start">
            <a
              href="https://wa.wizard.id/63b84f"
              class="anchol"
              target="_blank"
            >
              <v-btn
                x-large
                class="rounded-xl"
                depressed
                color="#53C764"
                dark
                elevation="2"
                ><v-icon class="mr-2">mdi-whatsapp</v-icon>Konsultasi
                Gratis</v-btn
              >
            </a>
          </div>
        </div>
      </div>
      <div class="wa_a_right d-flex justify-center align-item">
        <div class="content-wa-a-right"></div>
      </div>
    </div>
    <div class="wrap-wa-a-right-mobile">
      <div class="content-wa-a-right-mobile"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bannerBtmA",
};
</script>

<style>
.banner_wa_a {
  height: 100vh;
  position: relative;
  background: url("../../assets/img/penjurusan/asset1a.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  z-index: 1;
}
.wa_a_left {
  width: 50%;
}
.wa_a_right {
  width: 50%;
  height: 100vh;
}

.content-wa-a-right {
  width: 100%;
  height: 100vh;
  background: url("../../assets/img/penjurusan/banner-wa-a.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.wrap-wa-a-right-mobile {
  display: none;
}
@media (max-width: 576px) {
  .content-wa-a-right {
    display: none !important;
  }

  .wrap-wa-a-right-mobile {
    z-index: 3;
    display: flex;
    margin-top: -50%;
    background: url("../../assets/img/penjurusan/asset1a.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
  }

  .content-wa-a-right-mobile {
    z-index: 3;
    width: 100%;
    height: 50vh;
    background: url("../../assets/img/penjurusan/banner-wa-a.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .banner_wa_a {
    width: 100%;
  }

  .content-wa-a-left {
    text-align: center;
    margin-left: 70%;
  }
}
</style>
